import { render, staticRenderFns } from "./MobileCommunityBusinessnewsReply.vue?vue&type=template&id=1a395790&"
import script from "./MobileCommunityBusinessnewsReply.vue?vue&type=script&lang=js&"
export * from "./MobileCommunityBusinessnewsReply.vue?vue&type=script&lang=js&"
import style0 from "./MobileCommunityBusinessnewsReply.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports